import { Grid, Typography } from "@mui/material";
import { ListPolicyEdge } from "~/pages/inventory/asset/types";
import { PolicyResultDistribution } from "~/pages/inventory/components/PolicyScoreCard";
import { AssetScoreBox } from "../asset-score-box";

type PrintPolicySummaryHeaderProps = {
  listPolicyEdge: ListPolicyEdge;
};

export function PrintPolicySummaryHeader({
  listPolicyEdge,
}: PrintPolicySummaryHeaderProps) {
  const policy = listPolicyEdge.node;
  const { score, name, scoreStats } = policy;
  const { __typename, ...rest } = scoreStats || {};
  const stats = Object.entries(rest)
    .filter(([key, _value]) => ["passed", "failed", "exceptions"].includes(key))
    .map(([key, value]) => {
      if (key === "errors") {
        key = "errorscan";
      }

      return {
        result: key as keyof ListPolicyEdge["node"]["scoreStats"],
        value,
      };
    });

  return (
    <Grid
      container
      id={listPolicyEdge.node.mrn}
      sx={{
        pb: 4,
        px: 4,
        borderBottom: "1px solid #DBDADD",
      }}
    >
      <Grid container size="auto">
        <Grid size={12}>
          <Typography variant="h4" component="h3" fontSize={32}>
            {name}
          </Typography>
        </Grid>

        <Grid
          container
          columns={10}
          sx={{ alignItems: "end", ml: -1.25 }}
          size={5}
        >
          {stats.map((item) => (
            <Grid
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              key={item.result}
              size={2}
            >
              <PolicyResultDistribution result={item} />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid sx={{ ml: "auto" }} size="auto">
        <AssetScoreBox score={score} policyBox />
      </Grid>
    </Grid>
  );
}
